<ng-container
    *im2mLet="{
        unpacking: unpacking$ | async,
        routerTypes: routerTypes$ | async,
        routerTypeOptions: routerTypeOptions$ | async
    } as data"
>
    <h3 mat-dialog-title>
        {{ 'FIRMWARES.IMPORT.TITLE' | transloco }}
    </h3>
    <mat-dialog-content>
        <form [formGroup]="formGroup">
            <div class="import-wrapper">
                <div class="upload-area" liebherrDropFile (filesChanged)="onFilesChanged($event, $event)">
                    <ng-container *ngIf="data?.unpacking === false">
                        <span class="upload-hint">{{ 'FIRMWARES.IMPORT.DROP_FILE' | transloco }}</span>
                        <span class="browse-hint">{{ 'FIRMWARES.IMPORT.OR_BROWSE' | transloco }}</span>
                        <input type="file" #uploader [accept]="zipTypes" (change)="onFilesChanged($any($event?.target).files, $event)" />
                    </ng-container>

                    <div class="loading-hint" *ngIf="data?.unpacking === true">
                        <span>{{ 'FIRMWARES.IMPORT.EXTRACT_HINT' | transloco }}</span>
                        <mat-progress-spinner color="primary" [diameter]="16" mode="indeterminate"> </mat-progress-spinner>
                    </div>
                </div>
            </div>
            <div class="preview-wrapper">
                <div
                    class="errors"
                    *im2mLet="{
                        errors: errors$ | async,
                        zipError: zipError$ | async
                    } as erroData"
                >
                    <span *ngIf="erroData?.errors.type">{{ 'FIRMWARES.IMPORT.ERRORS.TYPE' | transloco }}</span>
                    <span *ngIf="erroData?.errors.count">{{ 'FIRMWARES.IMPORT.ERRORS.COUNT' | transloco }}</span>
                    <span *ngIf="erroData?.zipError">{{ erroData?.zipError | transloco }}</span>
                </div>
                <div class="information" *ngIf="formGroup.get('file')?.value">
                    <div class="info">
                        <div class="label">
                            {{ 'FIRMWARES.IMPORT.SELECTED_VERSION' | transloco }}
                        </div>
                        <div class="value">
                            <span class="file-name">{{ formGroup.get('version')?.value }}</span>
                        </div>
                    </div>
                    <div class="info">
                        <div class="label">
                            {{ 'FIRMWARES.IMPORT.SELECTED_FILE' | transloco }}
                        </div>
                        <div class="value">
                            <mat-icon color="primary">insert_drive_file</mat-icon><span class="file-name">{{ formGroup.get('file')?.value?.name }}</span
                            ><span class="file-size">{{ formGroup.get('file')?.value?.size | liebherrFormatFileSize }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>{{ 'DEVICES.IMPORT.ROUTER_TYPE' | transloco }}</mat-label>
                <mat-select formControlName="routerTypeId">
                    <mat-select-trigger>
                        {{ formGroup.get('routerTypeId')?.value | liebherrDisplayRouterType : data.routerTypes }}
                    </mat-select-trigger>
                    <div class="vendor-options" *ngFor="let vendor of data?.routerTypeOptions">
                        <div class="label">{{ vendor.vendor | uppercase }}</div>
                        <mat-option *ngFor="let type of vendor?.routerTypes" [value]="type.id">
                            {{ type.name }}
                        </mat-option>
                    </div>
                    <mat-option *ngIf="(data?.routerTypeOptions || []).length === 0">
                        {{ 'NO_DATA' | transloco }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formGroup.get('routerTypeId')?.hasError('required')">
                    <span class="error-hint">{{ 'DEVICES.IMPORT.ROUTER_TYPE_HINT' | transloco }}</span>
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel()">
            {{ 'CLOSE' | transloco }}
        </button>
        <button mat-flat-button color="primary" [disabled]="formGroup.invalid || formGroup.pristine" (click)="onSubmit()">
            {{ 'SUBMIT' | transloco }}
        </button>
    </mat-dialog-actions>
</ng-container>
